<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Y8OYlw/tc-custom/9781781263846.jpg?1703851147215" alt="This image is the cover for the book Debbie Shore's Sewing Room Secrets—Machine Sewing"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Debbie Shore's Sewing Room Secrets—Machine Sewing
      </h1>
      <p class="bookDescription body article font2">
        <p>In this first book in her new Sewing Room Secrets series, Debbie Shore walks you through every aspect of machine sewing, revealing her top tips and providing in-depth and helpful guidance every step of the way.   Starting by looking at sewing room essentials, Debbie then guides you around your sewing machine and explains all the tools and materials you might need, including wadding/batting, interfacing, fabrics and threads. There’s a handy troubleshooting section to reassure and guide you when you encounter problems.   Debbie covers the key techniques you need to know, including inserting zips and piping, using shirring elastic, free-motion embroidery and appliqué. Debbie’s focus is on craft and home items, but she also includes some dressmaking and quilting tips for those looking to explore other areas.   The ten beautiful projects help you learn the techniques as you progress through the book, beginning with a simple pincushion before moving on to a pillow cover, a tablet case, a drawstring bag, a sewing machine mat and more.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Debbie Shore
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Search Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?261b73d8